import React from 'react';
import {connect} from 'react-redux';
import Action from 'actions';
import BaseSortLineups from '../base-sort-lineups';

class SortLineups extends BaseSortLineups {
    constructor(props) {
        super(props);
        const {filters} = props;

        this.state = {
            sortBy: filters.sort,
            sortDirection: filters.sortDirection,
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const {filters} = this.props;
        const {filters: currentFilters} = prevProps;

        if (filters.sort !== currentFilters.sort || filters.sortDirection !== currentFilters.sortDirection) {
            this.setState({
                sortBy: filters.sort,
                sortDirection: filters.sortDirection,
            });
        }
    }

    onChange(e) {
        this.setState({
            sortBy: e.target.value,
        });
    }

    onClick() {
        const {filters} = this.props;

        const sort = {
            sortBy: this.state.sortBy,
            sortDirection: 'desc' === this.state.sortDirection ? 'asc' : 'desc',
        };

        if (filters.sort !== this.state.sortBy) {
            sort.sortDirection = 'desc';
        }

        this.props.dispatch(Action.set('SortLineups', sort));
    }

    render() {
        const items = this.getItems();
        const options = Object.keys(items).map((key) => (
            <option key={key} value={key}>
                {items[key]}
            </option>
        ));

        return (
            <div className="lineup-control">
                <label>Sort lineups:</label>
                <div className="lineup-control-holder">
                    <div className="input-group">
                        <select className="form-control" value={this.state.sortBy} onChange={((e) => this.onChange(e)).bind(this)}>
                            {options}
                        </select>
                        <span className="input-group-btn">
                            <button type="button" className="btn" onClick={this.onClick.bind(this)}>
                                Sort
                            </button>
                        </span>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {
        lineupsData: {filters},
        sportConfig,
    } = state;

    return {
        filters,
        sportConfig,
    };
}

export default connect(mapStatesToProps)(SortLineups);
